import { push } from 'react-router-redux'
import { ARTIST_PORTAL_ROUTE } from 'config'

export function signUpSuccess({ redirectUrl }) {
  return function (dispatch) {
    dispatch(push(redirectUrl || ARTIST_PORTAL_ROUTE))
  }
}
